import { render } from "./AddVpcOffering.vue?vue&type=template&id=e7cfb242&scoped=true"
import script from "./AddVpcOffering.vue?vue&type=script&lang=js"
export * from "./AddVpcOffering.vue?vue&type=script&lang=js"

import "./AddVpcOffering.vue?vue&type=style&index=0&id=e7cfb242&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7cfb242"]])

export default __exports__